// 0:通常 1:地下 2:荒廃 3:荒廃地下 4:マリス 5:マリス地下”
const missionlist = {
  Main: [
    { ID: "M1", name: "ベース251", status: "3" },
    { ID: "M2", name: "不法侵入者", status: "2" },
    { ID: "M3", name: "標準任務", status: "2" },
    { ID: "M4", name: "最優先駆除指令", status: "2" },
    { ID: "M5", name: "変わらぬ日々", status: "2" },
    { ID: "M6", name: "駆除チーム支援任務", status: "2" },
    { ID: "M7", name: "ハイブ処理任務", status: "2" },
    { ID: "M8", name: "牙の怪物", status: "2" },
    { ID: "M9", name: "訪問者", status: "2" },
    { ID: "M10", name: "翌日", status: "2" },
    { ID: "M11", name: "機械人間", status: "2" },
    { ID: "M12", name: "機械の巨人", status: "2" },
    { ID: "M13", name: "くだんの日", status: "2" },
    { ID: "M14", name: "転機", status: "0" },
    { ID: "M15", name: "駆除", status: "0" },
    { ID: "M16", name: "β型拡散", status: "0" },
    { ID: "M17", name: "ドローン襲来", status: "0" },
    { ID: "M18", name: "巨船破壊作戦", status: "0" },
    { ID: "M19", name: "K6作戦", status: "0" },
    { ID: "M20", name: "埠頭の乱戦", status: "0" },
    { ID: "M21", name: "銀白の船団", status: "0" },
    { ID: "M22", name: "サードマシン", status: "0" },
    { ID: "M23", name: "降下艇飛来", status: "0" },
    { ID: "M24", name: "光の塔", status: "0" },
    { ID: "M25", name: "狙撃部隊", status: "0" },
    { ID: "M26", name: "漂流者", status: "0" },
    { ID: "M27", name: "赤色機", status: "0" },
    { ID: "M28", name: "死の疾走", status: "0" },
    { ID: "M29", name: "擲弾兵", status: "0" },
    { ID: "M30", name: "第二次 巨船破壊作戦", status: "0" },
    { ID: "M31", name: "マザーの領域", status: "0" },
    { ID: "M32", name: "温泉郷の秘密", status: "0" },
    { ID: "M33", name: "翼の軍団", status: "0" },
    { ID: "M34", name: "海辺の巨塔", status: "0" },
    { ID: "M35", name: "崩れゆく街", status: "0" },
    { ID: "M36", name: "最後の抗戦", status: "0" },
    { ID: "M37", name: "烈火の大地", status: "0" },
    { ID: "M38", name: "ベース251", status: "3" },
    { ID: "M39", name: "標準任務‘", status: "2" },
    { ID: "M40", name: "変わらぬ日々‘", status: "2" },
    { ID: "M41", name: "訪問者‘", status: "2" },
    { ID: "M42", name: "翌日‘", status: "3" },
    { ID: "M43", name: "狂える世界", status: "2" },
    { ID: "M44", name: "神々の宴", status: "2" },
    { ID: "M45", name: "一番坑道", status: "3" },
    { ID: "M46", name: "くだんの日", status: "2" },
    { ID: "M47", name: "転機‘", status: "0" },
    { ID: "M48", name: "駆除‘", status: "0" },
    { ID: "M49", name: "アラネアの山", status: "0" },
    { ID: "M50", name: "危機迫る山頂", status: "0" },
    { ID: "M51", name: "擲弾破壊部隊", status: "0" },
    { ID: "M52", name: "邪神降臨", status: "0" },
    { ID: "M53", name: "砲兵進撃", status: "0" },
    { ID: "M54", name: "死の疾走‘", status: "0" },
    { ID: "M55", name: "矛と盾", status: "0" },
    { ID: "M56", name: "停船", status: "0" },
    { ID: "M57", name: "一つ目の巨人", status: "0" },
    { ID: "M58", name: "大空洞 調査作戦 上層", status: "1" },
    { ID: "M59", name: "大空洞 調査作戦 中層", status: "1" },
    { ID: "M60", name: "大空洞 調査作戦 下層", status: "1" },
    { ID: "M61", name: "蒼き怪鳥", status: "0" },
    { ID: "M62", name: "多重障壁", status: "0" },
    { ID: "M63", name: "激突する平原", status: "0" },
    { ID: "M64", name: "殿軍", status: "0" },
    { ID: "M65", name: "退路の敵", status: "0" },
    { ID: "M66", name: "降下戦機", status: "0" },
    { ID: "M67", name: "邪神街", status: "0" },
    { ID: "M68", name: "岩壁の巨影", status: "0" },
    { ID: "M69", name: "機械兵の砦", status: "0" },
    { ID: "M70", name: "異星の騎士", status: "0" },
    { ID: "M71", name: "レッドウォール作戦", status: "0" },
    { ID: "M72", name: "要塞追跡", status: "0" },
    { ID: "M73", name: "崩れゆく街‘", status: "0" },
    { ID: "M74", name: "要塞接近", status: "0" },
    { ID: "M75", name: "ベース251♰♰♰♰♰♰♰", status: "3" },
    { ID: "M76", name: "標準任務‘‘", status: "2" },
    { ID: "M77", name: "訪問者‘‘", status: "2" },
    { ID: "M78", name: "翌日‘‘", status: "2" },
    { ID: "M79", name: "狂える世界‘", status: "2" },
    { ID: "M80", name: "水神の宴", status: "2" },
    { ID: "M81", name: "二番坑道", status: "3" },
    { ID: "M82", name: "くだんの日♰♰♰♰♰♰♰", status: "2" },
    { ID: "M83", name: "破られた平穏", status: "0" },
    { ID: "M84", name: "未確認飛行物体", status: "0" },
    { ID: "M85", name: "怪物襲来", status: "0" },
    { ID: "M86", name: "広がる災禍", status: "0" },
    { ID: "M87", name: "死の疾走‘‘", status: "0" },
    { ID: "M88", name: "制圧者", status: "0" },
    { ID: "M89", name: "沿岸掃討計画", status: "0" },
    { ID: "M90", name: "急転直下", status: "0" },
    { ID: "M91", name: "魚群上陸", status: "0" },
    { ID: "M92", name: "船団監視計画", status: "0" },
    { ID: "M93", name: "眠れる巨鳥", status: "0" },
    { ID: "M94", name: "機械兵団 進撃", status: "0" },
    { ID: "M95", name: "待ち伏せ", status: "0" },
    { ID: "M96", name: "怪鳥撃滅計画", status: "0" },
    { ID: "M97", name: "激突する平原‘", status: "0" },
    { ID: "M98", name: "誘われる魚影", status: "0" },
    { ID: "M99", name: "燃える岸壁", status: "0" },
    { ID: "M100", name: "船団攻撃計画", status: "0" },
    { ID: "M101", name: "灼熱地帯", status: "0" },
    { ID: "M102", name: "装甲山脈", status: "0" },
    { ID: "M103", name: "怪物駆除計画", status: "0" },
    { ID: "M104", name: "潜水母艦防衛作戦", status: "0" },
    { ID: "M105", name: "第二次怪鳥撃滅計画", status: "0" },
    { ID: "M106", name: "陽動作戦", status: "0" },
    { ID: "M107", name: "ベース251♰♰♰♰♰♰♰♰", status: "0" },
    { ID: "M108", name: "戦術航空作戦", status: "0" },
    { ID: "M109", name: "エイリアン・アタック", status: "0" },
    { ID: "M110", name: "訪問者‘‘", status: "0" },
    { ID: "M111", name: "翌日‘‘", status: "3" },
    { ID: "M112", name: "狂える世界‘‘", status: "2" },
    { ID: "M113", name: "風神の宴", status: "2" },
    { ID: "M114", name: "三番坑道", status: "3" },
    { ID: "M115", name: "くだんの日♰♰♰♰♰♰♰♰", status: "2" },
    { ID: "M116", name: "本日の予定", status: "1" },
    { ID: "M117", name: "228基地の危機", status: "0" },
    { ID: "M118", name: "殲滅計画", status: "0" },
    { ID: "M119", name: "大空洞 調査任務", status: "1" },
    { ID: "M120", name: "死の疾走‘‘", status: "0" },
    { ID: "M121", name: "転送阻止作戦", status: "0" },
    { ID: "M122", name: "敵機襲来", status: "0" },
    { ID: "M123", name: "大空洞 破壊任務", status: "1" },
    { ID: "M124", name: "孵化", status: "0" },
    { ID: "M125", name: "休眠船団", status: "0" },
    { ID: "M126", name: "市街流入", status: "0" },
    { ID: "M127", name: "集結地点", status: "0" },
    { ID: "M128", name: "岩山の砦", status: "0" },
    { ID: "M129", name: "交錯する砲火", status: "0" },
    { ID: "M130", name: "特機戦隊", status: "0" },
    { ID: "M131", name: "無謀の賭け", status: "0" },
    { ID: "M132", name: "11番目の船", status: "0" },
    { ID: "M133", name: "ベース251♰♰♰♰♰♰♰♰♰", status: "1" },
    { ID: "M134", name: "粘糸の城郭", status: "0" },
    { ID: "M135", name: "エイリアン・アタック‘‘", status: "0" },
    { ID: "M136", name: "巨神激突", status: "0" },
    { ID: "M137", name: "訪問者‘‘", status: "0" },
    { ID: "M40.5", name: "変わらぬ日々‘‘", status: "1" },
    { ID: "M76.5", name: "極大勢力", status: "2" },
    { ID: "M134.5", name: "機兵大侵攻", status: "0" },
    { ID: "M118.5", name: "危機迫る山頂", status: "0" },
    { ID: "M128.5", name: "灯火なき街", status: "0" },
    { ID: "M130.5", name: "追跡者", status: "2" },
    { ID: "M144", name: "翌日``", status: "0" },
    { ID: "M145", name: "リング破壊作戦 前編", status: "0" },
    { ID: "M146", name: "リング破壊作戦 後編", status: "0" },
    { ID: "M147", name: "刻の天秤", status: "0" },
  ],
  DLC1: [
    { ID: "DLC1-M1", name: "228基地の危機", status: "0" },
    { ID: "DLC1-M2", name: "怪物襲来", status: "0" },
    { ID: "DLC1-M3", name: "滅びの楔", status: "0" },
    { ID: "DLC1-M4", name: "市街浸食", status: "0" },
    { ID: "DLC1-M5", name: "繁殖区域", status: "0" },
    { ID: "DLC1-M6", name: "無人爆撃編隊", status: "0" },
    { ID: "DLC1-M7", name: "災いの使役者", status: "0" },
    { ID: "DLC1-M8", name: "α群体 流入", status: "0" },
    { ID: "DLC1-M9", name: "飛行種襲来", status: "0" },
    { ID: "DLC1-M10", name: "大怪球", status: "0" },
    { ID: "DLC1-M11", name: "β群体 殺到", status: "0" },
    { ID: "DLC1-M12", name: "都市粉砕", status: "0" },
    { ID: "DLC1-M13", name: "降下兵団", status: "0" },
    { ID: "DLC1-M14", name: "山域調査作戦", status: "0" },
    { ID: "DLC1-M15", name: "闇の策謀", status: "1" },
    { ID: "DLC1-M16", name: "汚染地帯 前編", status: "0" },
    { ID: "DLC1-M17", name: "汚染地帯 後編", status: "0" },
    { ID: "DLC1-M18", name: "コードN", status: "0" },
  ],
  DLC2: [
    { ID: "DLC2-M1", name: "LV A-1 αアタック", status: "4" },
    { ID: "DLC2-M2", name: "LV A-2 βアタック", status: "4" },
    { ID: "DLC2-M3", name: "LV A-3 レッドアンカー", status: "4" },
    { ID: "DLC2-M4", name: "LV A-4 タイプ3 ハント", status: "4" },
    { ID: "DLC2-M5", name: "LV A-5 クルール ハント", status: "4" },
    { ID: "DLC2-M6", name: "LV A-6 クルール砲兵", status: "4" },
    { ID: "DLC2-M7", name: "LV B-1 ハイブ ブレイカー", status: "4" },
    { ID: "DLC2-M8", name: "LV B-2 高所狙撃", status: "4" },
    { ID: "DLC2-M9", name: "LV B-3 ザ・ピット", status: "5" },
    { ID: "DLC2-M10", name: "LV C-1 アンドロイド ハント", status: "4" },
    { ID: "DLC2-M11", name: "LV C-2 ビッグ アンドロイド", status: "4" },
    { ID: "DLC2-M12", name: "LV D-1 ハイグレード ハント", status: "4" },
    { ID: "DLC2-M13", name: "LV D-2 スカイアタック", status: "4" },
    { ID: "DLC2-M14", name: "LV D-3 狙撃塔", status: "4" },
    { ID: "DLC2-M15", name: "LV E-1 クラーケン ハント", status: "4" },
    { ID: "DLC2-M16", name: "LV E-2 ネイカーズ ハント", status: "4" },
    { ID: "DLC2-M17", name: "LV E-3 シップ アタック", status: "4" },
    { ID: "DLC2-M18", name: "LV F-1 フォール バック", status: "4" },
    { ID: "DLC2-M19", name: "LV F-2 ヘイズ ハント", status: "4" },
    { ID: "DLC2-M20", name: "LV F-3 サイレン コール", status: "4" },
    { ID: "DLC2-M21", name: "LV S-1 アンカーズ", status: "4" },
    { ID: "DLC2-M22", name: "LV S-2 マシン アタック", status: "4" },
    { ID: "DLC2-M23", name: "LV S-3 タイプ3×3", status: "4" },
    { ID: "DLC2-M24", name: "LV S-4 ザ・シールド", status: "4" },
    { ID: "DLC2-M25", name: "LV SS-1 クルーズ クルール", status: "4" },
    { ID: "DLC2-M26", name: "LV SS-2 ボトム フォールズ アウト", status: "5" },
    { ID: "DLC2-M27", name: "LV SS-3 空撃陣", status: "4" },
    { ID: "DLC2-M28", name: "LV SS-4 ザ・ビッグ", status: "5" },
    { ID: "DLC2-M29", name: "LV X-1 スノー マーチ", status: "4" },
    { ID: "DLC2-M30", name: "LV X-2 エイリアン サークル", status: "4" },
    { ID: "DLC2-M31", name: "LV Z-1 高速船", status: "4" },
    { ID: "DLC2-M32", name: "LV Z-2 デッド ケイブ", status: "5" },
    { ID: "DLC2-M33", name: "LV ZZ-1 ミッドナイト バトル", status: "4" },
    { ID: "DLC2-M34", name: "LV ZZZ-1 ザ・ポイズン", status: "4" },
    { ID: "DLC2-M35", name: "LV ZZZ-2 モンスター アタック", status: "4" },
    { ID: "DLC2-M36", name: "LV ZZZZ-A クラーケン ラッシュ", status: "4" },
    { ID: "DLC2-M37", name: "LV ZZZZ-S 黄金船団", status: "4" },
    { ID: "DLC2-M38", name: "LV ZZZZ-X ハイブ ラッシュ", status: "4" },
    { ID: "DLC2-M39", name: "LV ZZZZ-Y ラスト アタック", status: "4" },
    { ID: "DLC2-M40", name: "LV ZZZZ-Z ザ・リング", status: "4" },
  ],
};
export default missionlist;
